import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'utils/react';
import { BUILDER } from 'shared/abilities';
import { section } from '../decorators';

const BigMap = ({ children }) => {
  const [googleMap] = React.Children.toArray(children);

  return (
    <div>
      {googleMap}
    </div>
  );
};
BigMap.propTypes = {
  children: PropTypes.node.isRequired,
};

const component = compose(
  section(
    { name: 'Big Map', category: 'Maps' },
    {
      subsections: [
        { accepts: ['MapboxMapAllFacilities', 'MapboxMapOneFacility'] },
      ],
      defaults: ['MapboxMapAllFacilities'],
      menu: ({ children }) => ({
        items: [
          {
            label: 'Edit',
            iconClass: 'pencil',
            action: () => {
              const [googleMap] = React.Children.toArray(children);
              googleMap.props.onWidgetEditStart(googleMap.props.widget.id);
            },
          },
          'delete',
        ],
      }),
    },
  ),
)(BigMap);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
